import type { Editor } from '@tiptap/react';

export const insertGeneratedReply = (editor: Editor, html: string) => {
  editor.chain().focus().insertContentAt(0, html).run();
};
